import { Box, FormControl, FormControlLabel, Radio, RadioGroup, TextField, Typography,Button,FormLabel } from "@mui/material"
import React from "react"
export const Whatsappmodule=()=>{
  return(
    <div className="content">

      <Typography variant="h4" >
                Whatsapp Configuration
              </Typography>
       <Box border={1} borderRadius={2} p={3} m={6} >

            <Typography variant="h5" sx={{ mb: 2 }}>
              Whatsapp
            </Typography>
            <Typography
              variant="body2"
              sx={{
                mb: 2,
                display: "inline-block",
                
              }}
            >
             Please Place The Api Key From The Meta Developer Account
             
            </Typography>

            <FormControl component="fieldset" sx={{ mb: 2 ,ml:4}}>
              <RadioGroup row >
                <FormControlLabel value="active" control={<Radio color="success" />} label="Active" />
                <FormControlLabel value="inactive" control={<Radio color="error" />} label="Inactive" />
              </RadioGroup>
            </FormControl>
            <FormControl sx={{ mb: 2 }} fullWidth>
              <FormLabel htmlFor="two-factor">API Key</FormLabel>
              <TextField id="two-factor" name="two-factor"  variant="outlined" margin="normal" />
            </FormControl>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button variant="contained" color="success" >
                Save
              </Button>
            </Box>
          </Box>    </div>
  )
}